import db from './dexieConfig'

function getAssetUrl (ad) {
  if (ad.type === 'video') {
    return ad.video
  } else if (ad.type === 'image') {
    return ad.image
  } else if (ad.type === 'carousel') {
    return ad.cards?.[0]?.image || ad.cards?.[0]?.video
  } else {
    return null
  }
}

export async function checkAndCacheAll (newAds) {
  const seenAssetUrls = new Map()
  const deduplicatedAds = []

  for (const ad of newAds) {
    const assetUrl = getAssetUrl(ad)
    if (!assetUrl) {
      deduplicatedAds.push(ad)
    } else if (!seenAssetUrls.has(assetUrl)) {
      seenAssetUrls.set(assetUrl, true)
      deduplicatedAds.push(ad)
    }
  }

  const checkPromises = deduplicatedAds.map(async (ad) => {
    const assetUrl = getAssetUrl(ad)
    if (!assetUrl) {
      return { ad, exists: false }
    }
    const existing = await db.uniqueCreatives.where('assetUrl').equals(assetUrl).first()
    return { ad, exists: !!existing }
  })

  const checkResults = await Promise.all(checkPromises)
  const adsToAdd = checkResults.filter(result => !result.exists).map(result => result.ad)

  const adsToAddMapped = adsToAdd
    .filter(ad => getAssetUrl(ad))
    .map((ad) => ({
      assetUrl: getAssetUrl(ad)
    }))

  await db.uniqueCreatives.bulkPut(adsToAddMapped)

  return adsToAdd
}

export async function clearUniqueCreatives () {
  await db.uniqueCreatives.clear()
}
